import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import Dashboard from './pages/Dashboard';
import WorkflowEditor from './pages/WorkflowEditor';
import { Toaster } from 'sonner';
import './index.css';

function AppRouter() {
    return (
        <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/workflow/:workflowId" element={<WorkflowEditor />} />
            <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
    );
}

function App() {
    return (
        <div className="App dark">
            <BrowserRouter>
                <AppRouter />
            </BrowserRouter>
            <Toaster position="top-right" theme="dark" />
        </div>
    );
}

export default App;
